export default "__VITE_ASSET__DGHi3MEq__"